import styled from 'styled-components';
import { colors } from 'globalStyles';

export const PreviewScreen = styled.div`
  padding: 65px 0 28px !important;
  background-position: center !important;
`;

export const BackgroundImg = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 250.13px;
  height: 333.97px;
  margin: 36.28px 18.16px 35.96px 18.17px;
  z-index:0;

  &.pro {
    position: absolute;
    top: 0;
    left: 0;
    width: 266.13px;
    height: 381.97px;
    margin: 19.28px 16.16px 35.96px 16.17px;
    z-index: 0;
  }
`;

export const LogoImg = styled.img`
  width: 190.125px;
  height: 117px;
`;

export const LogoWrapper = styled.div`
  width: 190.125px;
  height: 117px;
  margin: 0px auto 13px;
  z-index: 1;
  position: relative;
`;

export const Title = styled.div`
  font-size: 11px;
  font-weight: 800;
  font-family: Proxima Nova;
  text-align: center;
  line-height: 13px;
  z-index: 1;
  position: relative;
`;

export const ButtonWrapper = styled.div`
  margin-top: 50px;
  position: relative;

  &.pro {
    margin-top: 130px
  }
`;

export const PlaceholderWrapper = styled.div`
  border: 0.56px solid ${colors.WHITE};
  height: 100%;
  width: 100%;
  padding-top: 36px;
  z-index: 1;
`;

export const PlaceholderText = styled.div`
  color: ${colors.WHITE};
  font-family: "Proxima Nova";
  font-size: 48px;
  font-weight: 600;
  line-height: 48px;
  font-weight: normal;
  text-align: center;
`;

export const BrowserPreviewScreen = styled.div`
  padding: 10px 0 !important;
  background-position: center !important;
  overflow: hidden;
`;

export const GalleryCopyWrapper = styled.div`
  width: 208.313px;
  max-height: 116.43px;
  margin: 0px auto;
  z-index: 1;
  position: relative;
`;

export const Headline = styled.div`
  font-size: 10px;
  text-align: center;
  line-height: 11px;
  z-index: 1;
  position: relative;
  padding-top: 8px;
  font-weight: bold;
  width: 145px;
  text-align: center;
  margin: 0 auto;

  &.sub {
    font-size: 6px;
    font-weight: 500;
    line-height: 8px;
    width: 140px;
  }
`;

export const GalleryButton = styled.div`
  line-height: 10px;
  >label {
    box-sizing: border-box;
    height: 14px;
    min-width: 81px;
    border: 1px solid #FFFFFF;
    font-size: 4px;
    line-height: 10px;
    font-weight: bold;
    margin: 0 auto;
    display: inline-block;
    padding: 0 5px;
  }
`;

export const GalleriesListWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  height: 52px;
  overflow: hidden;
  margin: 5px 0;
  img {
    width: 47px;
    height: 60px;
  }
`;


// WEBPACK FOOTER //
// ./src/components/DevicePreview/styledComponents.js